import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

/**
 * A very subtle, quick fade/slide transition to make page navigation feel
 * smooth and premium without causing motion sickness (dizziness).
 * 150ms duration is just enough to soften the hard cut.
 */
export default function PageTransition({ children }: { children: ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, filter: 'blur(2px)' }}
      animate={{ opacity: 1, filter: 'blur(0px)' }}
      exit={{ opacity: 0, filter: 'blur(2px)' }}
      transition={{ duration: 0.15, ease: 'easeInOut' }}
      className="w-full h-full flex flex-col flex-1"
    >
      {children}
    </motion.div>
  );
}
